module.exports = __webpack_public_path__ + "img/Banner_Home_2.baf698f3.png";